import merge from 'lodash/merge';
import { isMobile } from '@dkrm/general-libs/Utils/userAgentDetector';

/**
 * Recursively check and replace the style,
 * for platform spesific based on selectorDeviceType and delete all style
 * that contained in postfixList and return as a copy.
 *
 * @param {Object} style The style will be adjust.
 * @param {Function} selectorDeviceType The function to select current device type.
 * @param {Array} postfixList List of key will be removed in execution. Seperated using '_' (without single quote)
 *
 * @returns {Object} Return adjusted style, based on selector
 *
 *
 * @example
 *
 * const style = {
 *      h1: {
 *        fontSize_MOBILE: 33333333,
 *        fontSize: 36,
 *        h2: {
 *          fontSize_MOBILE: 22222222,
 *          fontSize: 32,
 *        },
 *        h3: {
 *          fontSize_MOBILE: 11111111,
 *          fontSize: 30,
 *        }
 *      }
 * };
 *
 * const newAdjustedStyle = getAdjustedStyles(style)
 * // MOBILE => { h1: { fontSize: 33333333, h2: { fontSize: 22222222 }, h3: { fontSize: 11111111 } }
 * // DEFAULT => { h1: { fontSize: 36, h2: { fontSize: 32 }, h3: { fontSize: 30 } }
 *
 */
export function getAdjustedStyles(style, selectorDeviceType = getCurrentDeviceType, postfixList = POSTFIX_LIST) {
  const currentStyle = merge({}, style);
  /* eslint-disable no-underscore-dangle */
  const currentDeviceType = selectorDeviceType();
  Object.entries(currentStyle).forEach(([key, val]) => {
    let trimKey = key;
    if (currentDeviceType !== '') {
      if (key.indexOf(currentDeviceType) > -1) {
        // replace existing key with platform spesific style
        trimKey = key.split('_')[0];
        currentStyle[trimKey] = val;
      }
    }
    if (key.split('_').length > 0 && postfixList.includes(`${key.split('_')[1]}`)) {
      // remove data if key exist in postfixList
      delete currentStyle[key];
    }
    if (typeof style[trimKey] === 'object') {
      // iterate again when data is object
      currentStyle[trimKey] = getAdjustedStyles(val, selectorDeviceType, postfixList);
    }
  });
  return currentStyle;
}
const POSTFIX_LIST = ['MOBILE'];
function getCurrentDeviceType() {
  if (isMobile()) {
    return 'MOBILE';
  }
  return ''; // DEFAULT
}